import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import { UserTeamDto, UserTeamKey } from 'api/Identity/Types/UserTeamDto'
import {
  CheckboxFilterCell,
  inputFilterCell,
  LanguagesFilterCell,
  multiSelectFilterCell,
} from 'components/Filter/FilterCell'
import { useAppSelector } from 'store'
import { formatUTCDate } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const InputFilterCell = inputFilterCell({
  options: {
    operator: 'like',
  },
})

const TeamsFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const teams = useAppSelector((state) => state.identity.teams)

  return multiSelectFilterCell({
    items: teams.map((x) => ({ id: x.id.toString(), value: x.id.toString(), label: x.name })),
    options: {
      operator: '==',
    },
  })(props)
}

const administrationUserTeamsColumn: GridColumn[] = [
  {
    title: 'User',
    field: UserTeamKey.user,
    filterCell: InputFilterCell,
    show: true,
    filterable: true,
  },
  {
    title: 'Teams',
    field: UserTeamKey.team,
    filterCell: TeamsFilterCell,
    show: true,
    filterable: true,
  },
  {
    title: 'Visibility',
    field: UserTeamKey.visibility,
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.visibility} disabled />
        </td>
      )
    },
    show: true,
    filterable: true,
  },
  {
    title: 'Communication Language',
    field: UserTeamKey.language,
    filterCell: LanguagesFilterCell,
    show: true,
    filterable: true,
  },
  {
    title: 'Auto assignment',
    field: UserTeamKey.autoAssignmentEnabled,
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.autoAssignmentEnabled} disabled />
        </td>
      )
    },
    show: true,
    filterable: true,
  },
  {
    title: 'Auto assignment (Paused)',
    field: 'isPausedAutoAssignment',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      const userTeamDto = props.dataItem as UserTeamDto
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={userTeamDto.user.isPausedAutoAssignment} disabled />
        </td>
      )
    },
    show: true,
  },
  {
    title: 'Auto Assignment (Paused) Start',
    field: 'autoAssignmentPausedStart',
    filterCell: () => null,
    filter: undefined,
    cell: (props: GridCellProps): JSX.Element => {
      const userTeamDto = props.dataItem as UserTeamDto
      if (userTeamDto.user.isPausedAutoAssignment && !userTeamDto.user.autoAssignmentPausedStart) {
        return <td className='table-columns__content'>Indefinite</td>
      }
      if (userTeamDto.user.autoAssignmentPausedStart) {
        return (
          <td align='center' style={{ textAlign: 'center' }}>
            <td className='clients-table-columns__date'>
              {formatUTCDate(userTeamDto.user.autoAssignmentPausedStart, false)}
            </td>
          </td>
        )
      }
      return <td className='table-columns__content'></td>
    },
    show: true,
  },
  {
    title: 'Auto Assignment (Paused) Until',
    field: 'autoAssignmentPausedUntil',
    filterCell: () => null,
    filter: undefined,
    cell: (props: GridCellProps): JSX.Element => {
      const userTeamDto = props.dataItem as UserTeamDto
      if (userTeamDto.user.isPausedAutoAssignment && !userTeamDto.user.autoAssignmentPausedUntil) {
        return <td className='table-columns__content'>Indefinite</td>
      }
      if (userTeamDto.user.autoAssignmentPausedUntil) {
        return (
          <td align='center' style={{ textAlign: 'center' }}>
            <td className='clients-table-columns__date'>
              {formatUTCDate(userTeamDto.user.autoAssignmentPausedUntil, false)}
            </td>
          </td>
        )
      }
      return <td className='table-columns__content'></td>
    },
    show: true,
  },
]

export default administrationUserTeamsColumn
